let settings = {
  development: {
    //"https://tbet.oddin-platform.com/virtualsweb"
    rocketServer: "http://crash-game-stage.api-core.com",
    //"http://51.68.181.111:44395"
  },
  production: {
    rocketServer: "https://tbet.oddin-platform.com",
  },
  testingMode: false,
};

export default settings;
